export default __webpack_public_path__ + "media/storefront/features/hymns/hymns/Ireland-385c063c10d1df227a0b7e2961d2f878.mp3";